const FILTER_KEYS = {
	"PROFESSION": "profession",
	"SPECIALTY": "specialty"
}

export { FILTER_KEYS }